export const enum LanguageEnum {
  TH = 'th',
  EN = 'en',
}
